import {Component, Input, OnInit} from "@angular/core";
import {Kpi} from "../../../../model/kpi";
import {KpisService} from "../../../../services/kpis.service";
import {translate} from "@ngneat/transloco";

@Component({
  selector: 'app-kpi-overview',
  templateUrl: './kpi-overview.component.html',
  styleUrls: ['./kpi-overview.component.scss']
})
export class KpiOverviewComponent implements OnInit {

  @Input()
  public kpi: Kpi;

  public activeDataCategories: string[];
  public activeData: any[];
  public noMeasurements: boolean;
  public loadingMeasurements: boolean;


  constructor(private kpisService: KpisService) {
    this.activeDataCategories = [translate('model.devices'),translate('model.asset'), translate('model.kpi')];
    this.activeData = [
      {name: translate('misc.overview.total'), data: null, color: '#DDDDDD' },
      {name: translate('misc.overview.withData'), data: null, color: '#3C97DA'},
      {name: translate('misc.overview.withDataToday'), data: null, color: '#8eda3c'}
    ];
  }

  ngOnInit(): void {
    this.loadKpiComponents();
  }

  private loadKpiComponents(): void {

  }


}
